// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const ChevronExpanded = (): React.Element<*> => (
  <path d="M10.006 12.75c-0 0-0 0-0.001 0-0.138 0-0.263-0.056-0.353-0.146v0l-4.5-4.5c-0.086-0.090-0.139-0.212-0.139-0.346 0-0.276 0.224-0.5 0.5-0.5 0.134 0 0.256 0.053 0.346 0.139l-0-0 4.147 4.147 4.146-4.147c0.090-0.086 0.212-0.139 0.346-0.139 0.276 0 0.5 0.224 0.5 0.5 0 0.134-0.053 0.257-0.139 0.346l-4.5 4.5c-0.090 0.090-0.215 0.146-0.353 0.146-0 0-0 0-0 0h0z"></path>
);
